import React, { FC, useMemo } from 'react'
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react'
import {
  CardGridContactsProps,
  ContactCard,
} from './types/CardGridContacts.types'
import './CardGridContacts.scss'

const CardGridContacts: FC<CardGridContactsProps> = ({
  fields: { CarouselCardHighlightsLists: cardList, Title: title },
}) => {
  const cardsMatrix: ContactCard[][] = useMemo(() => {
    let m: ContactCard[][] = []
    let l: ContactCard[] = [];
    cardList.forEach((e, i) => {
      if (l.length < 3) l.push(e)
      else {
        m.push(l)
        l = [e]
      }
      if (i === cardList.length - 1 && l.length > 0) m.push(l)
    })
    return m
  }, [cardList])

  return (
    <div className="CardGridContacts">
      {(title?.value?.length ?? 0) > 0 && <Text tag="h3" field={title} />}

      {cardsMatrix.map((row, idx) => (
        <div
          key={idx}
          className={`CardGridContacts__row ${
            idx ? 'CardGridContacts__row--margin-top' : ''
          } ${
            row.length > 2
              ? 'CardGridContacts__row_mt2'
              : 'CardGridContacts__row_lt3'
          }`}
        >
          {row.map(({ fields: card }, i) => (
            <div key={i}>
              <RichText tag="h4" field={card['Card Title']} />
              <RichText tag="h5" field={card['Card Text']} />
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default CardGridContacts
